/**
 * Intenção escolhida no cadastro ("Sou Cliente" | "Sou Profissional") — T1.19b, ADR 0039.
 *
 * O `signup-guard` grava-a em `app_metadata.signup_intent`, que só o servidor escreve; chega aqui por
 * `session.user`. 🔴 **A intenção nunca concede nada:** decide só o destino pós-login. O papel
 * continua a ser `consumer` até `promoteToProfessionalOwner`, e os dados continuam com a RLS.
 *
 * `null` quando ausente ou inválida — contas anteriores à T1.19b e seeds não têm a chave, e quem a
 * consome trata `null` como a entrada consumer.
 */

export type SignupIntent = 'consumer' | 'professional_owner';

const INTENCOES: readonly string[] = ['consumer', 'professional_owner'];

export function readSignupIntent(user: { app_metadata?: unknown } | null | undefined): SignupIntent | null {
  const metadata = user?.app_metadata;
  if (typeof metadata !== 'object' || metadata === null) return null;

  const intencao = (metadata as Record<string, unknown>).signup_intent;
  return typeof intencao === 'string' && INTENCOES.includes(intencao) ? (intencao as SignupIntent) : null;
}
